import { Time, DefinedTime } from '../types'

export const isTimeDefined = (time: Time): time is DefinedTime => {
  if (time.hour === null) return false
  if (time.minute === null) return false
  if (isNaN(time.hour)) return false
  if (isNaN(time.minute)) return false

  return true
}
